var render = function render(){var _vm=this,_c=_vm._self._c;return _c('landing-page',{attrs:{"chamber":_vm.config.key,"chamberTitle":_vm.config.name,"loading":_vm.loading,"models":_vm.models,"currentModel":_vm.model,"landingModels":_vm.landingModels}},[_c('span',{attrs:{"slot":"page-title"},slot:"page-title"},[_vm._v("2020 "+_vm._s(_vm.config.name)+" Elections Model")])])
}
var staticRenderFns = []

export { render, staticRenderFns }